import {
    IconAlertTriangle,
    IconEdit,
    IconClipboard,
    IconFileUpload,
    IconZoom,
    IconCircleCheck,
    IconCircleX,
    IconArrowBackUp,
    IconCheck,
} from '@tabler/icons-react';

// color: 'alert' | 'info' | 'success' | 'error' | 'default'
const EVENT_DATA = {
    created: {
        label: 'Contestação aberta',
        description: 'A contestação foi registrada pelo provedor de pagamento.',
        icon: IconAlertTriangle,
        color: 'alert',
    },
    updated: {
        label: 'Contestação atualizada',
        description: 'Informações da contestação foram atualizadas.',
        icon: IconEdit,
        color: 'default',
    },
    evidence_required: {
        label: 'Documentos solicitados',
        description: 'O provedor solicitou o envio de evidências para análise.',
        icon: IconClipboard,
        color: 'alert',
    },
    evidence_submitted: {
        label: 'Evidências enviadas',
        description: 'As evidências foram enviadas para análise do provedor.',
        icon: IconFileUpload,
        color: 'info',
    },
    under_review: {
        label: 'Em análise',
        description: 'A contestação está sendo analisada pelo provedor de pagamento.',
        icon: IconZoom,
        color: 'info',
    },
    won: {
        label: 'Contestação ganha',
        description: 'A contestação foi resolvida a seu favor.',
        icon: IconCircleCheck,
        color: 'success',
    },
    lost: {
        label: 'Contestação perdida',
        description: 'A contestação foi resolvida a favor do titular do cartão.',
        icon: IconCircleX,
        color: 'error',
    },
    reversed: {
        label: 'Contestação revertida',
        description: 'A decisão da contestação foi revertida.',
        icon: IconArrowBackUp,
        color: 'default',
    },
    closed: {
        label: 'Contestação encerrada',
        description: 'A contestação foi encerrada.',
        icon: IconCheck,
        color: 'default',
    },
    warning: {
        label: 'Aviso',
        description: 'Um aviso foi emitido sobre esta contestação.',
        icon: IconAlertTriangle,
        color: 'alert',
    },
};

const EVENT_FALLBACK = {
    label: 'Evento desconhecido',
    description: '',
    icon: IconAlertTriangle,
    color: 'default',
};

export function getChargebackEvent(type) {
    return EVENT_DATA[type] || { ...EVENT_FALLBACK, label: type || EVENT_FALLBACK.label };
}

export const ACTOR_LABELS = {
    provider: 'Processador de pagamento',
    seller: 'Você',
    buyer: 'Comprador',
    system: 'Sistema',
};

export function getActorLabel(actor) {
    return ACTOR_LABELS[actor] || actor || '';
}

export default EVENT_DATA;
